var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19981 2.1499C2.28854 2.1499 1.5498 2.88863 1.5498 3.7999V18.1999C1.5498 19.1112 2.28854 19.8499 3.1998 19.8499H12.7998C13.7111 19.8499 14.4498 19.1112 14.4498 18.1999V3.79992C14.4498 2.88865 13.7111 2.14992 12.7998 2.14992L3.19981 2.1499ZM0.0498047 3.7999C0.0498047 2.0602 1.46011 0.6499 3.19981 0.649902L12.7998 0.649916C14.5395 0.649919 15.9498 2.06022 15.9498 3.79992V18.1999C15.9498 19.9396 14.5395 21.3499 12.7998 21.3499H3.1998C1.46011 21.3499 0.0498047 19.9396 0.0498047 18.1999V3.7999ZM4.2498 4.99992C4.2498 4.58571 4.58559 4.24992 4.9998 4.24992H10.9998C11.414 4.24992 11.7498 4.58571 11.7498 4.99992C11.7498 5.41413 11.414 5.74992 10.9998 5.74992H4.9998C4.58559 5.74992 4.2498 5.41413 4.2498 4.99992ZM7.2498 15.7999C7.2498 15.3857 7.58559 15.0499 7.9998 15.0499H8.08481C8.49903 15.0499 8.83481 15.3857 8.83481 15.7999V15.8768C8.83481 16.291 8.49903 16.6268 8.08481 16.6268H7.9998C7.58559 16.6268 7.2498 16.291 7.2498 15.8768V15.7999Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/Phone.dd6a44c62ce128d3c2df3d161c349da6.svg";
export { ForwardRef as ReactComponent };